function initProductFeatures( )
{
    document.querySelectorAll( ".js-pf-collapse" ).forEach( element =>
    {
        element.addEventListener( "click", function(  )
        {
            var text = this.querySelector( ".product_features_support_text_container" );
            var icon = this.querySelector( ".bridgman-filter-chevron" );
            if ( text )
            {
                if ( text.style.height == "0px" )
                {
                    text.style.height = text.scrollHeight + "px";
                    if ( icon )
                    {
                        icon.classList.remove( "fa-chevron-down" );
                        icon.classList.add( "fa-chevron-up" );
                    }

                }
                else
                {
                    text.style.height = "0px";
                    if ( icon )
                    {
                        icon.classList.add( "fa-chevron-down" );
                        icon.classList.remove( "fa-chevron-up" );
                    }
                }
            }
        });
    });

    window.addEventListener( "resize", function( )
    {
        if ( this.innerWidth < 769 )
        {
            document.querySelectorAll( ".js-pf-collapse" ).forEach( element =>
            {
                var text = element.querySelector( ".product_features_support_text_container" );
                var icon = element.querySelector( ".bridgman-filter-chevron" );
                if ( text )
                {
                    text.style.height = "0px";
                }
                if ( icon )
                {
                    icon.classList.add( "fa-chevron-down" );
                    icon.classList.remove( "fa-chevron-up" );
                }
            });
        }
    });
}

initProductFeatures( );